import { render, staticRenderFns } from "./hold_edit.vue?vue&type=template&id=610a9e75&scoped=true&"
import script from "./hold_edit.vue?vue&type=script&lang=js&"
export * from "./hold_edit.vue?vue&type=script&lang=js&"
import style0 from "./hold_edit.vue?vue&type=style&index=0&id=610a9e75&lang=less&scoped=true&"
import style1 from "./hold_edit.vue?vue&type=style&index=1&id=610a9e75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a9e75",
  null
  
)

export default component.exports